// 🧾 Semaines LMDS — numérotation dimanche–samedi, IDENTIQUE à `backend/services/lmds_semaines.py` (test de parité).
export function premierDimanche(annee) {
  const jan1 = new Date(annee, 0, 1);
  return new Date(annee, 0, 1 + ((7 - jan1.getDay()) % 7));
}

export function getWeekDates(annee, semaine) {
  const start = premierDimanche(annee);
  start.setDate(start.getDate() + (semaine - 1) * 7);
  const end = new Date(start);
  end.setDate(end.getDate() + 6);
  return { start, end };
}

export function nbSemaines(annee) {
  const d = premierDimanche(annee + 1);
  const p = premierDimanche(annee);
  return Math.round((d - p) / (7 * 86400000));
}

const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const bornesSemaineISO = (annee, semaine) => { const { start, end } = getWeekDates(annee, semaine); return [iso(start), iso(end)]; };

export function libelleSemaine(annee, semaine) {
  if (!annee || !semaine) return '';
  const { start, end } = getWeekDates(annee, semaine);
  const f = (d) => d.toLocaleDateString('fr-CA', { day: 'numeric', month: 'long', year: start.getFullYear() !== end.getFullYear() ? 'numeric' : undefined });
  return `du ${f(start)} au ${f(end)}${start.getFullYear() === end.getFullYear() ? ` ${end.getFullYear()}` : ''}`;
}
